module.exports = __webpack_public_path__ + "static/media/endometrialcancer.05471f09.svg";